import { Translate } from '@chipinside/translate'
import { toast } from 'sonner'

import type { TranslationKey } from '#/@types/translate'
import { listeners } from '#/utils/listeners'

const FormBuilderFunctions = {
  dispatchEvents: () => {
    /**
     * Dispara eventos para recarregar informações, como datagrid, animal e listbuilder
     * após o fechamento do modal de resposta.
     */
    ;[listeners.pagebuilder, listeners.datagrid, listeners.listbuilder, listeners.animal].forEach(
      event => window.dispatchEvent(new Event(event)),
    )
  },

  toast: (props: any) => toast?.[props?.level]?.(props?.title, { description: props?.message }),
  translate: (props: any) =>
    Translate({ messageKey: props?.key as TranslationKey, params: props?.params }),
}

export { FormBuilderFunctions }
